import UpdateVoiceFileRequest from '../../../../../Spirit/Admin/Interfaces/Models/UpdateVoiceFileRequest';

export default class UpdateMeditationTranslationRequest  {
	LangCode?: string = '';
	Name?: string = '';
	Description?: string = '';
	VoiceFiles: Array<UpdateVoiceFileRequest> = null;
	constructor(obj?: Partial<UpdateMeditationTranslationRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
